import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://mcorlywwlskdktvxqhtx.supabase.co';
const SUPABASE_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1jb3JseXd3bHNrZGt0dnhxaHR4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzc1NjU2NjcsImV4cCI6MjA5MzE0MTY2N30.BrEVC94XzPCcmjtZMedRKL8EX1nLtOghbCNMDhG25Wo';

export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);
